import React, { useState } from "react";

const ToggleBtn = ({ onToggle, isChecked }) => {
  const handleChange = (e) => {
    const checked = e.target.checked;
    if (onToggle) onToggle(checked);
  };

  return (
    <>
      <label className="flex cursor-pointer select-none items-center">
        <div className="relative">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleChange}
            className="sr-only"
          />
          <div
            className={`box block h-6 w-[2.57rem] rounded-full ${
              isChecked ? "bg-success" : "bg-danger"
            }`}
          ></div>
          <div
            className={`absolute left-1 top-1 flex h-4 w-4 items-center justify-center rounded-full bg-white transition ${
              isChecked ? "translate-x-full" : ""
            }`}
          ></div>
        </div>
        <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
          {isChecked ? "Active" : "Inactive"}
        </span>
      </label>
    </>
  );
};

export default ToggleBtn;
